import React, { Fragment, useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import "./grivencepage.css";
import Loading from "../Loading/Loading";

const GrivencePage = () => {
    const [loading, setLoading] = useState(true);

    const fraFeesData = [
        {
            title: "Feedback",
            link: "https://gnvsiom.in/forms/render/WJXT4BU7JONKQ0VF",
        },
        {
            title: "Grievance",
            link: "https://gnvsiom.in/page/grievance",
        },
    ];

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    return (
        <Fragment>
            {loading && <Loading />}

            {!loading && (
                <div className="nirf-page-container container">
                    <div className="nirf-page-table-container">
                        <table className="nirf-page-table">
                            <tbody>
                                {fraFeesData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}.</td>
                                        <td>{item.title}</td>
                                        <td className="nirf-page-pdf">
                                            <a
                                                href={item.link}   // ✅ FIX HERE
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FaEye className="nirf-page-pdf-view" />
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default GrivencePage;